import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-null-transaction-type",
  // imports: [],
  templateUrl: "./null-transaction-type.component.html",
  styleUrl: "./null-transaction-type.component.css",
  standalone: false,
})
export class NullTransactionTypeComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
